import { useAccountSettingsBootstrapQuery } from "@/query/accountSettingsQuery";
import { useUserSessionStore } from "@/stores/v2/userSessionStore";

/**
 * Subscribes to account settings for the active appliance so session modals and other UI can read
 * {@link useAccountSettingsUse24Hour} (from TanStack Query cache) without opening My Account Settings.
 */
export function AccountSettingsBootstrap(): null {
	const applianceId = useUserSessionStore((s) => s.active_device as string);
	useAccountSettingsBootstrapQuery(applianceId);
	return null;
}
